import ReactDOM from "react-dom/client";
import { useEffect, useRef, useState } from "react";
// import "./index.css";
import "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import "./assets/scss/index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { SnackbarProvider } from "notistack";
import { SnackbarUtilsConfigurator } from "./components/NotistackPlus";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { LicenseInfo } from '@mui/x-license-pro';
import { AwsRum, AwsRumConfig } from 'aws-rum-web';
import { useUrfReceiveEvents } from "./hooks/urfEvents";
import { useConfigStore } from "./store/config";
import Loading from "./components/Loading";
import { initI18n } from "./locals/index";
LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE_KEY as string);

// const startLocalWorker = async () => {
//   if (process.env.NODE_ENV === 'development') {
//     const {worker} = await import ('./mocks/browser')
//     return worker.start();
//   }
// }
// startLocalWorker();

// configure AWS RUM
const rumConfig = {
  identityPoolId: process.env.REACT_APP_AWS_RUM_IDENTITY_POOL_ID as string,
  endpoint: process.env.REACT_APP_AWS_RUM_ENDPOINT as string,
  applicationId: process.env.REACT_APP_AWS_RUM_APPLICATION_ID as string,
  applicationVersion: process.env.REACT_APP_AWS_RUM_APPLICATION_VERSION as string,
  applicationRegion: process.env.REACT_APP_AWS_RUM_APPLICATION_REGION as string,
  telemetries: (process.env.REACT_APP_AWS_RUM_TELEMETRIES as string)?.split(','),
  allowCookies: process.env.REACT_APP_AWS_RUM_ALLOW_COOKIES === 'true',
  enableXRay: process.env.REACT_APP_AWS_RUM_ENABLE_XRAY === 'true',
  sessionSampleRate: parseFloat(process.env.REACT_APP_AWS_RUM_SESSION_SAMPLE_RATE || "1"),
};
const {
  sessionSampleRate,
  identityPoolId,
  endpoint,
  telemetries,
  allowCookies,
  enableXRay,
} = rumConfig;
try {
  const config: AwsRumConfig = {
    sessionSampleRate,
    identityPoolId,
    endpoint,
    telemetries,
    allowCookies,
    enableXRay,
  };

  const APPLICATION_ID = rumConfig.applicationId;
  const APPLICATION_VERSION = rumConfig.applicationVersion;
  const APPLICATION_REGION = rumConfig.applicationRegion;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const awsRum: AwsRum = new AwsRum(
    APPLICATION_ID,
    APPLICATION_VERSION,
    APPLICATION_REGION,
    config
  );
} catch (error) {
  // Ignore errors thrown during CloudWatch RUM web client initialization
}

const queryClient = new QueryClient();

const LanguageGate = () => {
  useUrfReceiveEvents();
  const [language] = useConfigStore((state) => [state.language]);
  const [i18nReady, setI18nReady] = useState(false);
  const initGenRef = useRef(0);

  useEffect(() => {
    initGenRef.current += 1;
    const gen = initGenRef.current;
    setI18nReady(false);
    let cancelled = false;

    initI18n(language)
      .then(() => {
        if (!cancelled && gen === initGenRef.current) {
          setI18nReady(true);
        }
      })
      .catch((err) => {
        console.error(err);
        if (!cancelled && gen === initGenRef.current) {
          setI18nReady(true);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [language]);

  if (!i18nReady) {
    return <Loading open />;
  }

  return (
    <SnackbarProvider
      maxSnack={2}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <SnackbarUtilsConfigurator />
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </SnackbarProvider>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>
  // <SnackbarProvider
  //   maxSnack={1}
  //   anchorOrigin={{ vertical: "top", horizontal: "center" }}
  // >
  //   <SnackbarUtilsConfigurator />
  //   <QueryClientProvider client={queryClient}>
  //     <App />
  //   </QueryClientProvider>
  // </SnackbarProvider>
  <LanguageGate />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
